export const CLEAR_STORE = 'CLEAR_STORE';
export const SET_ACTIVE_DROPDOWN = 'SET_ACTIVE_DROPDOWN';
export const SET_SELECTED_ADDRESS_LOCATION = 'SET_SELECTED_ADDRESS_LOCATION'
export const SET_BASEMAP = 'SET_BASEMAP'


export const setActiveDropdown = dropdownId => {
  return { type: SET_ACTIVE_DROPDOWN, payload: dropdownId };
};

export const setSelectedAddressLocation = location => {
  return { type: SET_SELECTED_ADDRESS_LOCATION, payload: location };
};

export const setBasemap = data => {
  return { type: SET_BASEMAP, payload: data}
}

// Tells the root reducer to completely clear the redux store, used for 401 encounters
export const clearStore = () => ({ type: CLEAR_STORE, payload: true });
